import { render, staticRenderFns } from "./HistoryDetailBuyerLayout.vue?vue&type=template&id=d96ce468&scoped=true"
import script from "./HistoryDetailBuyerLayout.vue?vue&type=script&lang=js"
export * from "./HistoryDetailBuyerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ce468",
  null
  
)

export default component.exports